import { Stepper } from 'modules/shared/components';

/**
 * AnalystPrimaryStepper component
 * @param {Object} props
 * @param {Array} props.primarySteps
 * @param {number} props.activeStep
 * @param {Function} props.onStepClick
 * @returns {JSX.Element}
 */
export default function AnalystPrimaryStepper({ primarySteps, activeStep, onStepClick }) {
  return (
    <Stepper
      steps={primarySteps}
      activeStep={activeStep}
      onStepClick={onStepClick}
      sx={{ width: '100%', maxWidth: 720, alignSelf: 'center' }}
    />
  );
}
